export const getFileExtension = (filename) =>
filename ? filename.substr(filename.lastIndexOf('.') + 1) : '';